export default __webpack_public_path__ + "locales/sr-Latn-RS/ChangeUserTypeDialog.json?hash=7f0cef46e5925529c5a459e4fc71ae81";